import { render, staticRenderFns } from "./BaseBtn.vue?vue&type=template&id=52e5e6c0"
import script from "./BaseBtn.vue?vue&type=script&lang=js"
export * from "./BaseBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports